import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { updateOutfitEntities, updateOutfitEntitiesForAllLocales } from './outfits.actions';
import { AppState } from '../../reducers';
import { reject, isNil, map, values, find, propEq, uniq } from 'ramda';
import { MediaItem } from '../Media/media.reducer';

export interface Profile {
  attrType: string;
  id: number;
  name: string;
  profileImage: MediaItem;
  slug: string;
  type: string;
}

export interface Outfit {
  id: number;
  title: string;
  imageUrl: string;
  slug: string;
  profile: Profile;
}

export interface Outfits {
  [key: number]: {
    byId: {
      [key: string]: Outfit;
    };
  };
}

const initialState = Immutable.from<Outfits>({});

export type OutfitsState = Outfits & Immutable.ImmutableObject<Outfits>;

export default function reduce(
  state: OutfitsState = initialState,
  action: Action
) {
  if (isType(action, updateOutfitEntities)) {
    const {
      payload: { appId, outfits },
    } = action;

    if (!outfits) {
      return state;
    }

    return state.merge(
      {
        [appId]: {
          byId: outfits,
        },
      },
      { deep: true }
    );
  }

  if (isType(action, updateOutfitEntitiesForAllLocales)) {
    const {
      payload: { appIds = [], outfits },
    } = action;

    if (!outfits) {
      return state;
    }

    const newEntities = appIds.reduce((acc, currentAppId) => {
      return {
        ...acc,
        [currentAppId]: {
          byId: outfits,
        },
      };
    }, {});

    return state.merge(
      { ...newEntities },
      { deep: true }
    );
  }

  return state;
}

export function getOutfitsByIds(
  state: AppState,
  appId: number,
  ids: number[]
): Outfit[] {
  const {
    entities: { outfits },
  } = state;

  if (!ids || !outfits) {
    return [];
  }

  return reject(
    isNil,
    map(
      id => outfits[appId] && outfits[appId].byId && outfits[appId].byId[id],
      uniq(ids)
    )
  );
}

export function getOutfitsByAppId(state: AppState, appId: number) {
  const {
    entities: { outfits },
  } = state;
  return outfits[appId] && values(outfits[appId].byId);
}

export function getOutfitById(
  state: AppState,
  appId: number,
  outfitId: number
): Outfit | undefined {
  const outfits = getOutfitsByIds(state, appId, [outfitId]);
  if (!outfits || outfits.length === 0) {
    return;
  }

  return find(propEq('id', outfitId))(outfits) as Outfit | undefined;
}



// WEBPACK FOOTER //
// ./src/store/Entities/Outfits/outfits.reducer.ts